import { USER_LOGIN, USER_LOGOUT } from "./actionTypes";

export const loginUser = (user) => {
  return {
    type: USER_LOGIN,
    payload: user,
  };
};

export const logoutUser = () => {
  localStorage.removeItem("infoSalonsUser");
  return {
    type: USER_LOGOUT,
    payload: null,
  };
};
